import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/login.css';
import { API_BASE } from '../utils/api';
import { useTranslation } from '../utils/i18n';

function Login() {
 const { t } = useTranslation();
 const handleLogin = () => {
  window.location.href = `${API_BASE}/auth/login`;
 };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Drone Hotel</h1>
        <p style={{ color: '#666', fontSize: '14px', textAlign: 'center', marginBottom: '24px' }}>
          {t('Sign in with your Drone Hotel account')}
        </p>
        <button
          className="btn btn-login w-100"
          onClick={handleLogin}
        >
          {t('Login')}
        </button>
      </div>
    </div>
  );
}

export default Login;
